import React, { Component } from 'react'
import Helmet from 'react-helmet'
import moment from 'moment'
import cloudinary from 'cloudinary-core'
import { CLOUDINARY_NAME } from '../../../constants/images/cloudinary'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
})

class ProductSchema extends Component {
  constructor(props) {
    super(props)

    const { productData } = this.props

    let productImages = []

    if (productData.bike_images.length > 0) {
      for (let i = 0; i < productData.bike_images.length; i++) {
        productImages.push(
          //1024x768
          cl.url(productData.bike_images[i].bike_image_cloudinary_public_id, {
            gravity: 'center',
            height: 768,
            width: 1024,
            crop: 'fill',
            format: 'jpg',
          })
        )
      }
    }

    let productDescription =
      productData.bike_year.toString() +
      ' ' +
      productData.bike_make +
      ' ' +
      productData.bike_model +
      ' motorcycle rental in ' +
      productData.bike_location.location_city +
      ', ' +
      productData.bike_location.location_region_abbr +
      '. ' +
      productData.bike_description

    let productReviews = []

    if (productData.bike_guest_reviews.length > 0) {
      for (let i = 0; i < productData.bike_guest_reviews.length; i++) {
        productReviews.push({
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: productData.bike_guest_reviews[i].guest_review_name
              ? productData.bike_guest_reviews[i].guest_review_name
              : 'No Author Name',
          },
          datePublished: moment(
            productData.bike_guest_reviews[i].guest_review_date
          ).format('MMM D, YYYY'),
          reviewBody:
            productData.bike_guest_reviews[i].guest_bike_review_text +
            ' ' +
            productData.bike_guest_reviews[i].guest_owner_review_text,
          reviewRating: {
            '@type': 'Rating',
            bestRating: 5,
            ratingValue: productData.bike_guest_reviews[i].guest_review_rating,
            worstRating: 1,
          },
        })
      }
    }

    let aggregateRating = {
      '@type': 'AggregateRating',
      bestRating: 5,
      name:
        productData.bike_year.toString() +
        ' ' +
        productData.bike_make +
        ' ' +
        productData.bike_model,
      ratingCount: productData.bike_review_count,
      ratingValue: productData.bike_overall_rating,
      worstRating: 1,
    }

    const productSchemaBuild = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name:
        productData.bike_year.toString() +
        ' ' +
        productData.bike_make +
        ' ' +
        productData.bike_model,
      image: productImages,
      description: productDescription,
      mpn:
        productData.bike_year +
        ' ' +
        productData.bike_make +
        ' ' +
        productData.bike_model,
      sku:
        productData.bike_year +
        ' ' +
        productData.bike_make +
        ' ' +
        productData.bike_model,
      brand: {
        '@type': 'Brand',
        name: productData.bike_make,
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.twistedroad.com' + productData.bike_url,
        priceCurrency: 'USD',
        price: productData.bike_daily_price_cents / 100,
        availability: 'https://schema.org/InStock',
        areaServed:
          productData.bike_location.location_city +
          ', ' +
          productData.bike_location.location_region_abbr,
      },
    }

    if (productReviews.length > 0) {
      productSchemaBuild['review'] = productReviews
      productSchemaBuild['aggregateRating'] = aggregateRating
    }

    this.state = {
      productSchema: productSchemaBuild,
    }
  }

  render() {
    const { productSchema } = this.state

    return (
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
    )
  }
}

export default ProductSchema

ProductSchema.defaultProps = {
  productData: {},
  url: 'https://www.twistedroad.com',
}
